import { Component, OnInit } from '@angular/core';
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';
import { LogsService } from 'src/app/utils/services/logs.service';
import { switchMap } from 'rxjs';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    standalone: false
})
export class ForbiddenComponent implements OnInit {

  constructor(
    private authService: AuthorizationServiceProvider,
    private logger: LogsService
  ) { }

  ngOnInit(): void {
    this.logger.log(`[Forbidden] opened`);
    this.authService.getAuthDetailsService().pipe(
      switchMap(auth => auth.getUserRole())
    ).subscribe({
      next: role => this.logger.log(`[Forbidden] userRole=${role}`),
      error: err => this.logger.log(`[Forbidden] failed to resolve role`, err)
    });

    this.authService.getAuthDetailsService().pipe(
      switchMap(auth => auth.getSelfSchoolId())
    ).subscribe({
      next: schoolId => this.logger.log(`[Forbidden] userSchoolId=${schoolId}`),
      error: err => this.logger.log(`[Forbidden] failed to resolve schoolId`, err)
    });

    this.authService.getAuthDetailsService().subscribe({
      next: auth => {
        this.logger.log(
          `[Forbidden] tokenExists=${auth.tokenExists()} tokenValid=${auth.isTokenValid()}`
        );
      },
      error: err => this.logger.log(`[Forbidden] failed to resolve auth details`, err)
    });
  }

  onLogout() {
    this.authService.getCommonRoutines().subscribe(service => service.logout())
  }
}
